import { useMutation } from '@tanstack/react-query';

import {
  companyPartnerOnboardingService,
  CreateCompanyWithConnectionRequest,
  CreateCompaniesWithConnectionsResponse,
} from '@aslanpay/portal-common-lib';

/**
 * Creates a company and connection for each request, applying every valid row rather than rolling the whole
 * batch back on one bad row - confirms the companies selected from a Cezanne sync (or any other
 * discovery-driven flow) into real Aslan companies.
 */
const useCreateCompaniesWithConnections = () => {
  return useMutation<
    CreateCompaniesWithConnectionsResponse,
    Error,
    CreateCompanyWithConnectionRequest[]
  >((requests) => companyPartnerOnboardingService.createCompaniesWithConnections(requests));
};

export default useCreateCompaniesWithConnections;
